import { useContext, useEffect, useRef, useState } from "react";
import PieChart from "./PieChart";
import BarChartNivo from "./BarChartJS";
import { getBarChart, getPieChart } from "../../service/AnalyticsService";
import {
  BAR_CHART_COLORS,
  BAR_CHART_COLORS_ALLMODALITIES,
  PIE_CHART_COLORS,
  BAR_CHART_COLORS_AI_RESULT,
} from "../../constants/Constants";
import { DefaultButton, PrimaryButton } from "@fluentui/react";
import AnalyticsFilter from "./AnalyticsFilter";
import { t } from "i18next";
import { useQuery, useQueryClient } from "@tanstack/react-query";

import Moment from "moment";
import loaderContext from "../../context/loader/LoaderContext";
import userContext from "../../context/users/UserContext";
import LineChartNivo from "./LineChartNivo";
import MultiLineChartNivo from "./MultiLineChartNivo";
import TATCombinedChart from "./TATCombinedChart";
import { ChoiceGroup } from "@fluentui/react";
import { set } from "date-fns";
import StudyDrilldownTable from "./StudyDrilldownTable";
import { useLocation } from "react-router-dom";
import analyticsContext from "../../context/analytics/analyticsContext";
import { getStudyDrilldownData } from "../../service/AnalyticsService";
import themeContext from "../../context/theme/ThemeContext";

const ChartComponent = (props) => {
  const {themeName} = useContext(themeContext);
  const location = useLocation();
  let incomingChartMode = location.state?.widgetChartMode;
  let incomingChartDateFrom = location.state?.chartDateFrom;
  let incomingChartDateTo = location.state?.chartDateTo;
  let widgetModalityIds = location.state?.modalityIds || [];

  console.log("Chart Mode:", incomingChartMode);
  console.log("Chart Date From:", incomingChartDateFrom);
  console.log("Chart Date To:", incomingChartDateTo);

  const { widgetModeOpen, setWidgetModeOpen } = useContext(analyticsContext);
   
  const queryClient = useQueryClient();
  const [data, setData] = useState([]);
  const [keys, setKeys] = useState([]);
  const [indexBy, setIndexBy] = useState("");
  const [yAxisText, setYAxisText] = useState();
  const [xAxisUnit, setXAxisUnit] = useState("");
  const [yAxisUnit, setYAxisUnit] = useState();
  const [showFilterOptions, setShowFilterOptions] = useState(true);
  //const [heightForContainer, setHeightForContainer] = useState((props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count") ? "70%" : "90%");
  const [previousFilterObj, setPreviousFilterObj] = useState(null);

  const [drilldownTableData, setDrilldownTableData] = useState([]);
  const [showDrilldownTable, setShowDrilldownTable] = useState(false);
  const [selectedDrilldownDate, setSelectedDrilldownDate] = useState(null);
  let tatPointClickTimer = null;
  const [filtersCleared, setFiltersCleared] = useState(false);

  const chartWrapperRef = useRef(null);
  const [chartContainerWidth, setChartContainerWidth] = useState(0);
  const isPortraitMode = window.innerHeight > window.innerWidth && window.innerWidth >= 800;
  const [showMoreFilters, setShowMoreFilters] = useState(false);

  useEffect(() => {
    const el = chartWrapperRef.current;
    if (!el) return;
    const ro = new ResizeObserver(([entry]) => {
      setChartContainerWidth(entry.contentRect.width);
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  const fetchStudyDrilldownDataNow = async (clickedDate) => {
  const res = await getStudyDrilldownData(
    clickedDate,
    {
      ...payloadWithOutGlobalFilter.chartConfigDto,
      modalityIds,
      hospitalIds: clientIds,
      userIds: providerIds,
      bodyParts,
      aiModel,
      normality,
      dateFrom: clickedDate,
      dateTo: clickedDate,
    },
    clientIds,
    providerIds
  );

  if (res.status === 200) {
    setDrilldownTableData(res.data.data || []);
  }
};
  const handleTATPointDoubleClick = (dateLabel) => {
    if (tatPointClickTimer !== null) {
      clearTimeout(tatPointClickTimer);
      tatPointClickTimer = null;

      // Save the current filters before drilldown
      setPreviousFilterObj({ ...filterObjInChartComponent });
      const clickedDate = new Date(dateLabel);  // bar label → Date object

    // Switch to fullDay mode (just one date picker)
    setFilterObjInChartComponent(prev => ({
      ...prev,
      dateFrom: clickedDate,
      dateTo: clickedDate,
      fullDay: true
    }));
      const formattedDate = new Date(dateLabel).toISOString().split("T")[0]; // "YYYY-MM-DD"
      setSelectedDrilldownDate(clickedDate);
      setShowDrilldownTable(true);
    fetchStudyDrilldownDataNow(formattedDate); 
    } else {
      tatPointClickTimer = setTimeout(() => {
        clearTimeout(tatPointClickTimer);
        tatPointClickTimer = null;
      }, 300);
    }
  };
  useEffect(() => {
  const newHeight = getHeightForContainer(props.chartType);
  setHeightForContainer(newHeight);
}, [props.chartType, showDrilldownTable]);


  const getHeightForContainer = (chartType) => {
    if (props.chartType === "ai_tat_analysis" && showDrilldownTable) {
    return "calc(100% - 140px)";
  }
  switch (chartType) {
    case "edit_reports_count":
    case "returned_studies_count":
    case "raised_alert_count":
      return "70%";
    case "radiologist_tat_trend":
      return "calc(100% - 140px)";
    case "ai_tat_analysis":
      return "calc(100% - 68px)";
    case "ai_result":
      return "calc(100% - 75px)";
    case "study_throughput":
    case "tat_analysis":
      return "90%";
    default:
      return "90%";
  }
};



 const [heightForContainer, setHeightForContainer] = useState(getHeightForContainer(props.chartType));


  const [modalityIds, setModalityIds] = useState(() => {
    // If chart mode is enabled, use modalityIds coming from location state
    if (incomingChartMode) {
      return widgetModalityIds;
    }

    // Existing logic
    if (
      props.chartType === "edit_reports_count" ||
      props.chartType === "returned_studies_count" ||
      props.chartType === "raised_alert_count"
    ) {
      return props.allModalitySelected;
    }

    return [];
  });

  useEffect(() => {
    console.log("Modality Ids updated:", modalityIds);
  }, [modalityIds]);

  const [clientIds, setClientIds] = useState([]);
  const [pathologyIds, setPathologyIds] = useState(() => props.chartType !== "pathology_count" ? [] : [
    "Tuberculosis",
    "Cardiomegaly",
    "Pleural Effusion",
    "COVID Suspect",
  ]);

  const [providerIds, setProviderIds] = useState([]);
  const [userIds, setUserIds] = useState(()=>props.chartType=="edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count" ? props.allRadiologistSelected : []);
  const { ref, setLoaderRunning } = useContext(loaderContext);
  const { roles } = useContext(userContext);
  const [selectedDate , setSelectedDate] = useState(2);
  const [dateByInComponent, setDateByInComponent] = useState(1);
  const [totalCountForStudies, setTotalCountForStudies] = useState(0);
  const [returnedReasonIds, setReturnedReasonIds] = useState(()=> props.chartType == "returned_studies_count" ? props.allReturnedReasonSelected : []);
  const [raiseAlertReasonIds, setRaiseAlertReasonIds] = useState(()=> props.chartType == "raised_alert_count" ? props.allRaiseAlertReasonSelected : []);
  const [bodyParts, setBodyParts] = useState([]);
  const [aiModel, setAiModel] = useState([]);
  const [normality, setNormality] = useState("total");
  const [doubleClicked, setDoubleClicked] = useState(false);
  const today = new Date();
  const toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate()-1);

  const todayDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const last2DaysDate = new Date(today.getFullYear(), today.getMonth(), today.getDate()-1);
  const last3DaysDate = new Date(today.getFullYear(), today.getMonth(), today.getDate()-2);
  const lastWeekDate = new Date(today.getFullYear(), today.getMonth(), today.getDate()-6);
  const lastMonthDate = new Date(today.getFullYear(), today.getMonth()-1, today.getDate());

  const defaultTime = new Date();
  defaultTime.setHours(12, 0, 0, 0);

  const defaultTimeStr = "12:00";

  const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(todayDate.getMonth() - 1);

  const sevenDaysAgo = new Date();
  sevenDaysAgo.setDate(todayDate.getDate() - 7); // Includes today

  const defaulteFromDate = (
    props.chartType === "tat_analysis"
  ) ? sevenDaysAgo : (
    props.chartType === "study_throughput" ||
    props.chartType === "radiologist_tat_trend" ||
    props.chartType === "ai_tat_analysis" ||
    props.chartType === "ai_result"
  ) ? oneMonthAgo : last2DaysDate;

  const [filterObjInChartComponent, setFilterObjInChartComponent] = useState(() => {
    let dateFrom;
    let dateTo;

    if (props.chartType === "radiologist_tat_trend" || props.chartType === "ai_tat_analysis" || props.chartType === "ai_result") {
      dateFrom = incomingChartDateFrom 
        ? new Date(incomingChartDateFrom.split("T")[0]) 
        : defaulteFromDate;

      dateTo = incomingChartDateTo 
        ? new Date(incomingChartDateTo.split("T")[0]) 
        : todayDate;
    } else {
      // always fallback to defaults for other chart types
      dateFrom = defaulteFromDate;
      dateTo = todayDate;
    }
    return {
      dateTo,
      dateFrom,
      timeFrom: defaultTime,
      timeTo: defaultTime,
      fullDay: false
    };
  });

  const [selectedTATType, setSelectedTATType] = useState(
    incomingChartMode || "study_scan_tat_trend"
  );

   useEffect(() => {
  if (showDrilldownTable && filterObjInChartComponent.fullDay) {
    setSelectedDrilldownDate(filterObjInChartComponent.dateFrom);
    // if (filterObjInChartComponent.dateFrom) {
    //   fetchData();
    // }
  }
}, [filterObjInChartComponent.dateFrom]);

  const formatDate = (date) => {
    var currentDate = Moment(date).local().format("DD-MMM-YYYY");
    return date == "" ? "" : currentDate;
  };

  const formatTime = (timeStr) => {
    return typeof timeStr === 'string' ? timeStr : null;
  };

  var payload = {
    chartConfigDto: {
      chartType: props.chartType,
      filter: props.dateBy == 1 ? "upload_date" : "study_date",
      dateFrom: formatDate(props.filterObj["dateFrom"]),
      dateTo: formatDate(props.filterObj["dateTo"]),
      selfTat: 0,
    },
  };
  
  var payloadWithOutGlobalFilter = {
    chartConfigDto: {
      chartType: props.chartType,
      filter: dateByInComponent == 1 ? "upload_date" : "study_date",
      dateFrom: formatDate(filterObjInChartComponent["dateFrom"]),
      dateTo: formatDate(filterObjInChartComponent["dateTo"]),
      // filter: props.objForEditedStudies != null ? props.objForEditedStudies["filter"] : "",
      // dateFrom: props.objForEditedStudies != null ? props.objForEditedStudies["dateFrom"] : "",
      // dateTo: props.objForEditedStudies != null ? props.objForEditedStudies["dateTo"] : "",
      // dateFrom: formatDate(last2DaysDate),
      // dateTo: formatDate(todayDate),
      timeFrom:  formatTime(filterObjInChartComponent.timeFrom),// assuming "HH:mm" string
      timeTo:  formatTime(filterObjInChartComponent.timeTo),
      selfTat: 0,
      fullDay: false
    },
  };

  const handleResetChart = () =>{
    setClientIds([]);
    setModalityIds(props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count" ? props.allModalitySelected : []);
    setProviderIds([]);
    setUserIds(props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count" ? props.allRadiologistSelected : []);
    setSelectedDate(2);
    setDateByInComponent(1);
    setReturnedReasonIds(props.chartType == "returned_studies_count" ? props.allReturnedReasonSelected : []);
    setRaiseAlertReasonIds(props.chartType == "raised_alert_count" ? props.allRaiseAlertReasonSelected : []);
    setBodyParts([]);
    setAiModel([]);
    setNormality("");
    setTimeout(() => {
      dataQuery.refetch();
    },100)
  }

  useEffect(()=>{
    let date = new Date();
    let toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    console.log("today Date: ", toDate);
    if(props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count"){
      if(selectedDate == 1){
        date = todayDate;
      }else if(selectedDate == 2){
        date = last2DaysDate;
      }else if(selectedDate == 3){
        date = last3DaysDate;
      }else if(selectedDate == 4){
        date = lastWeekDate;
      }else if(selectedDate == 5){
        date = lastMonthDate;
      }else{
        date = payloadWithOutGlobalFilter?.chartConfigDto?.dateFrom != undefined ? new Date(payloadWithOutGlobalFilter?.chartConfigDto?.dateFrom) : date;
        toDate = payloadWithOutGlobalFilter?.chartConfigDto?.dateTo != undefined ? new Date(payloadWithOutGlobalFilter?.chartConfigDto?.dateTo) : todayDate;
      }
      console.log("date , toDate---", date, toDate);
      setFilterObjInChartComponent({ ...filterObjInChartComponent, dateFrom: date, dateTo: toDate });
    }
  },[selectedDate]);

  const fetchTAT = (payload) => {
    return fetchBarChart(payload);
  };

  const fetchStudyOnPlatform = (payload) => {
    return fetchBarChart(payload);
  };

  const fetchStudyThrouhput = (payloadWithOutGlobalFilter) => {
    return fetchBarChart(payloadWithOutGlobalFilter);
  };


  const fetchGenderWiseDistribution = (payload) => {
    return fetchBarChart(payload);
  };

  const fetchReportingStatus = (payload) => {
    return fetchBarChart(payload);
  };

  const fetchEditedReportsOnPlatform = (payloadWithOutGlobalFilter) => {
    return fetchBarChart(payloadWithOutGlobalFilter);
  }

  const fetchReturnedStudiesOnPlatform = (payloadWithOutGlobalFilter) => {
    return fetchBarChart(payloadWithOutGlobalFilter);
  }

  const fetchRaiseAlertStudiesOnPlatform = (payloadWithOutGlobalFilter) => {
    return fetchBarChart(payloadWithOutGlobalFilter);
  }

  const fetchAllRadCountsForEditiedOrReturnedOrRaisedCharts = (entries) => {
    let temp = [];
    let count = 0;
    temp = entries.map((e)=>{
      let name = e[0];
      count += e[1][0][name];
    })
    setTotalCountForStudies(count);
    return count;
  }

  const fetchBarChart = async (payload) => {
    setLoaderRunning(true);
    ref.current.continuousStart();
    let finalPayload = props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count" || props.chartType === "ai_tat_analysis" || props.chartType == "study_throughput" || props.chartType === "tat_analysis" ? payloadWithOutGlobalFilter : payload;
    //let finalPayload = props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count" || props.chartType == "study_throughput" || props.chartType === "tat_analysis" ? payloadWithOutGlobalFilter : payload;
    if (props.chartType === "radiologist_tat_trend") {
      finalPayload.chartConfigDto.chartType = selectedTATType;
    }    
    console.log("payload:::...",finalPayload);
    let response = await getBarChart(finalPayload);
    let totalCount = 0;
    if (response.status === 200) {
      const data = response.data.data;

      let chartData = data.chartData && Object.keys(data.chartData).length > 0
        ? data.chartData
        : data.sortedChartData || {};

      let objectEntries = Object.entries(chartData);
      console.log("Object entries----", objectEntries);

      if (props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count") {
        totalCount = fetchAllRadCountsForEditiedOrReturnedOrRaisedCharts(objectEntries);
      }
      
      let objectEntriesLengthUp = objectEntries.length * 30;
      //let height = (props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count") ? objectEntries.length > 15 ? objectEntriesLengthUp+"px" : '70%' : '90%';
      let height;

        if (
          props.chartType === "edit_reports_count" || 
          props.chartType === "returned_studies_count" || 
          props.chartType === "raised_alert_count"
        ) {
          height = objectEntries.length > 15 ? objectEntriesLengthUp + "px" : "70%";
        } else if (props.chartType === "ai_result") {
          height = "calc(100% - 75px)";
        } else if (props.chartType === "ai_tat_analysis" && showDrilldownTable) {
          height = "calc(100% - 50px)";
        }else if (props.chartType === "ai_tat_analysis") {
          height = "calc(100% - 68px)";
        }else if (props.chartType === "radiologist_tat_trend") {
          height = "calc(100% - 140px)";
        } 
        else if (
          props.chartType === "study_throughput" ||
          props.chartType === "tat_analysis" 
        ) {
          height = "90%";
        } else {
          height = "90%";
        }

        setHeightForContainer(height);
      // props.objForEditedStudies != null && props.setObjForEditedStudies({
      //   dateFrom: formatDate(filterObjInChartComponent["dateFrom"]),
      //   dateTo: formatDate(filterObjInChartComponent["dateTo"]),
      //   selectedDate: selectedDate,
      //   dateByInComponent: dateByInComponent,
      //   totalCounts: props.totalCountForStudies
      // });



      let tempList = [];
      let tempKeys = [];
      let indexByTemp = "";
      let yaxis = "";
      let yAxisUnit = "";
      let xAxisUnit = "";
      if (props.chartType == "report_count") {
        indexByTemp = "Hospitals";
        yaxis = "No. of studies";
        setIndexBy(indexByTemp);
        setYAxisText(yaxis);
      } else if (props.chartType == "upload_count") {
        indexByTemp = "Hospitals";
        yaxis = "No. of studies";
        setIndexBy(indexByTemp);
        setYAxisText(yaxis);
      } else if (props.chartType == "gender_count") {
        indexByTemp = "Pathology";
        yaxis = "No. of studies";
        setIndexBy(indexByTemp);
        setYAxisText(yaxis);
      } else if (props.chartType == "user_count") {
        indexByTemp = "Providers";
        yaxis = "Turn Around Time in Minutes";
        setIndexBy(indexByTemp);
        setYAxisText(yaxis);
      } else if (props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count") {
        indexByTemp = "No of studies";
        yaxis = "Radiologists";
        setIndexBy(indexByTemp);
        setYAxisText(yaxis);
      }else if (props.chartType == "study_throughput") {
        indexByTemp = "Reported Date";
        yaxis = "Number of Reported Studies";
        if(filterObjInChartComponent.fullDay){
          indexByTemp = "Reported Time";
          xAxisUnit = "hh";
        }else{
          xAxisUnit = "DD-MM-YYYY";
        }
        setIndexBy(indexByTemp);
        setYAxisText(yaxis);
        setXAxisUnit(xAxisUnit);
      }else if (props.chartType === "ai_result") { 
        indexByTemp = "AI Inference Date";
        yaxis = "Number of AI Inferenced Studies";
        if(filterObjInChartComponent.fullDay){
          indexByTemp =  "Reported Time";
          xAxisUnit = "hh";
        } else {
          xAxisUnit= "DD-MMM-YYYY";
        }
        setIndexBy(indexByTemp);
        setYAxisText(yaxis);
        setXAxisUnit(xAxisUnit);
  //     } 
  //     else if (props.chartType === "radiologist_tat_trend") {
  //  // Transform backend response for line chart
  //       const lineDataObject = response.data.data.sortedChartData;

  //       const tempList = Object.entries(lineDataObject).map(([date, valueArray]) => {
  //         return {
  //           x: date,
  //           "Average TAT": valueArray?.[0]?.["Average TAT"] ?? 0
  //         };
  //       });

  //       setData(tempList);
  //       setKeys(["Average TAT"]);
  //       setYAxisText("Study/Reporting TAT (HH:mm:ss)");
  //       setIndexBy("x"); 
  //       const xAxisLabel = "Reported Date";
  //       setLoaderRunning(false);
  //       ref.current.complete();

  //       return {
  //         chartType: props.chartType,
  //         chartData: tempList,
  //         chartKeys: ["Average TAT"],
  //         indexby: "x",
  //         yAxisText: "Average TAT (HH:MM:SS)",
  //         xAxisText: xAxisLabel
  //       }
      }else if (props.chartType === "tat_analysis") {
        indexByTemp = "Reported Date";
        yaxis = "TAT";
        xAxisUnit = "DD-MM-YYYY";
        yAxisUnit = "mm:ss";
        setIndexBy(indexByTemp);
        setYAxisText(yaxis);
        setXAxisUnit(xAxisUnit);
        setYAxisUnit(yAxisUnit);
        const keyMap = {
            "Top-TAT": "Top 25% TAT",
            "Mid-TAT": "Mid 50% TAT",
            "Bottom-TAT": "Bottom 25% TAT"
        };

        for (let [dateKey, categoriesArray] of objectEntries) {
            let totalForDate = 0;
            categoriesArray.forEach(categoryObj => {
                Object.values(categoryObj).forEach(value => {
                    totalForDate += value;
                });
            });

            const barEntry = { [indexByTemp]: dateKey };

            categoriesArray.forEach(categoryObj => {
                Object.entries(categoryObj).forEach(([categoryName, value]) => {
                    const renamedKey = keyMap[categoryName] || categoryName;

                    barEntry[renamedKey] = value;

                    if (!tempKeys.includes(renamedKey)) {
                        tempKeys.push(renamedKey);
                    }
                });
            });
            tempList.push(barEntry);
        }
      }
      // else if (props.chartType == "ai_tat_analysis") {
      //   const lineChartData = [
      //     { id: "Minimum TAT", data: [] },
      //     { id: "Average TAT", data: [] },
      //     { id: "Maximum TAT", data: [] },
      //   ];

      //   for (let [key, value] of objectEntries) {
      //     const date = key;

      //     let min = null, max = null, avg = null;

      //     value.forEach((entryObj) => {
      //       for (const [label, val] of Object.entries(entryObj)) {
      //         if (label === "Minimum TAT") min = val;
      //         else if (label === "Maximum TAT") max = val;
      //         else if (label === "Average TAT") avg = val;
      //       }
      //     });

      //     if (min !== null) {
      //       lineChartData[0].data.push({ x: date, y: min });
      //     }
      //     if (avg !== null) {
      //       lineChartData[1].data.push({ x: date, y: avg });
      //     }
      //     if (max !== null) {
      //       lineChartData[2].data.push({ x: date, y: max });
      //     }
      //   }

      //   setData(lineChartData);
      //   setYAxisText("AI TAT (seconds)");
      //   setLoaderRunning(false);
      //   ref.current.complete();

      //   return {
      //     chartType: props.chartType,
      //     chartData: lineChartData,
      //     chartKeys: ["Minimum TAT", "Average TAT", "Maximum TAT"],
      //     indexby: "x", // not used in line chart, safe to leave
      //     yAxisText: "AI TAT (seconds)",
      //     xAxisText: "Submit Date",
      //     selectedDate: selectedDate,
      //     totalCountForStudies: totalCount,
      //     heightForContainer: height
      //   };
      // }

      else if (props.chartType === "ai_tat_analysis" || props.chartType === "radiologist_tat_trend") {
        const lineChartData = [
          { id: "Minimum TAT", data: [] },
          { id: "Average TAT", data: [] },
          { id: "Maximum TAT", data: [] },
        ];

        const rechartsData = [];

        for (let [key, value] of objectEntries) {
          const date = key;

          let min = null, max = null, avg = null;

          value.forEach((entryObj) => {
            for (const [label, val] of Object.entries(entryObj)) {
              if (label === "Minimum TAT") min = val;
              else if (label === "Maximum TAT") max = val;
              else if (label === "Average TAT") avg = val;
            }
          });

          if (min !== null) lineChartData[0].data.push({ x: date, y: min });
          if (avg !== null) lineChartData[1].data.push({ x: date, y: avg });
          if (max !== null) lineChartData[2].data.push({ x: date, y: max });

          // Populate combined data for Recharts
          rechartsData.push({
            x: date,
            min: min ?? null,
            avg: avg ?? null,
            max: max ?? null,
          });
        }

        // Update with Recharts-style data
        setData(rechartsData);
        setYAxisText("AI TAT (seconds)");
        setLoaderRunning(false);
        ref.current.complete();

        return {
          payload,
          payloadWithOutGlobalFilter,
          chartType: props.chartType,
          chartData: rechartsData, // <--- return recharts-ready data
          chartKeys: ["Minimum TAT", "Average TAT", "Maximum TAT"],
          indexby: "x", // safe to leave for compatibility
          yAxisText: "AI TAT (seconds)",
          xAxisText: "Submit Date",
          selectedDate: selectedDate,
          totalCountForStudies: totalCount,
          heightForContainer: height,
        };
      }


      

      if (props.chartType !== "tat_analysis"){
        for (let [key, value] of objectEntries) {
          let obj = {};
          obj[indexByTemp] = key;
          value.forEach((v, index) => {
            obj[Object.keys(v)[0]] = Object.values(v)[0];
            //obj[`${Object.keys(v)[0]}Color`] = BAR_CHART_COLORS[index];
            if (props.chartType === "ai_result") {  
              obj[`${Object.keys(v)[0]}Color`] = BAR_CHART_COLORS_AI_RESULT[index];
            } else {
              obj[`${Object.keys(v)[0]}Color`] = BAR_CHART_COLORS[index];
            }
            if (!tempKeys.includes(Object.keys(v)[0])) {
              tempKeys.push(Object.keys(v)[0]);
            }
          });
          obj["AllModalitiesColor"] = BAR_CHART_COLORS_ALLMODALITIES;
          tempList.push(obj);
        }
      }

      setKeys(tempKeys);
      setData(tempList);
     
      // setKeys(tempKeys);
      setLoaderRunning(false);
      ref.current.complete();
      console.log("totalCountForStudies, count----------------",totalCountForStudies, totalCount);
      return {
        payload,
        payloadWithOutGlobalFilter,
        chartType: props.chartType,
        chartData: tempList,
        chartKeys: tempKeys,
        indexby: indexByTemp,
        yAxisText: yaxis,
        xAxisUnit: xAxisUnit,
        yAxisUnit: yAxisUnit,
        selectedDate: selectedDate,
        totalCountForStudies: totalCount,
        heightForContainer: height
      };
    } else {
      setLoaderRunning(false);
      ref.current.complete();
    }
  };

  const fetchPieChart = async (payload) => {
    setLoaderRunning(true);
    ref.current.continuousStart();
    const response = await getPieChart(payload);
    if (response.status === 200) {
      let responseList = response.data.data.chartData;
      responseList.forEach((element, index) => {
        element.color = PIE_CHART_COLORS[index];
      });
      setData(responseList);
      setLoaderRunning(false);
      ref.current.complete();
      return {
        payload,
        chartType: props.chartType,
        chartData: responseList,
        chartKeys: undefined,
      };
    } else {
      setLoaderRunning(false);
      ref.current.complete();
    }
  };

  const fetchData = async () => {
    const start = filterObjInChartComponent?.dateFrom;
    const end = filterObjInChartComponent?.dateTo;

    if (start && end) {
      const diffInMs = new Date(end) - new Date(start);
      const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

      const maxAllowedDays = props.chartType === "tat_analysis" ? 7 : 31;

      if (diffInDays > maxAllowedDays) {
        props.setAlertSuccessModal(() => ({
          ...props.alertSuccessModal,
          show: true,
          heading: "Warning",
          description: `Please select a date range within ${maxAllowedDays} days.`,
        }));
        return;
      }
    }

    if (props.isBar || props.isLine ||  props.isLineAvg) {
      if (props.chartType == "upload_count") {
        if (modalityIds.length > 0) {
          payload["chartConfigDto"]["modalityIds"] = modalityIds;
        }
        if (clientIds.length > 0) {
          payload["chartConfigDto"]["hospitalIds"] = clientIds;
        }
        return fetchStudyOnPlatform(payload);
      } else if (props.chartType == "gender_count") {
        if (pathologyIds.length > 0) {
          payload["chartConfigDto"]["annotationIds"] = pathologyIds;
        }
        return fetchGenderWiseDistribution(payload);
      } else if (props.chartType == "report_count") {
        if (clientIds.length > 0) {
          payload["chartConfigDto"]["hospitalIds"] = clientIds;
        }
        return fetchReportingStatus(payload);// || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count"
      } else if (props.chartType == "edit_reports_count") {
        if (modalityIds.length > 0) {
          payloadWithOutGlobalFilter["chartConfigDto"]["modalityIds"] = modalityIds;
        }
        if (userIds.length > 0) {
          payloadWithOutGlobalFilter["chartConfigDto"]["userIds"] = userIds;
        }else{
          props.setAlertSuccessModal(() => {
            const newItem = { ...props.alertSuccessModal };
            newItem.show = true;
            newItem.heading = "Alert";
            newItem.description = t("analytics.min-radiologist-selected");
            return newItem;
          });
      }
        return fetchEditedReportsOnPlatform(payloadWithOutGlobalFilter);
      }else if (props.chartType == "returned_studies_count") {
        if (modalityIds.length > 0) {
          payloadWithOutGlobalFilter["chartConfigDto"]["modalityIds"] = modalityIds;
        }
        if (userIds.length > 0) {
          payloadWithOutGlobalFilter["chartConfigDto"]["userIds"] = userIds;
        }else{
            props.setAlertSuccessModal(() => {
              const newItem = { ...props.alertSuccessModal };
              newItem.show = true;
              newItem.heading = "Error";
              newItem.description = t("analytics.min-radiologist-selected");
              return newItem;
            });
        }
        if(returnedReasonIds.length > 0){
          payloadWithOutGlobalFilter["chartConfigDto"]["returnedReasons"] = returnedReasonIds;
        }else{
          payloadWithOutGlobalFilter["chartConfigDto"]["returnedReasons"] = [];
        }
        return fetchReturnedStudiesOnPlatform(payloadWithOutGlobalFilter);
      }else if (props.chartType == "raised_alert_count") {
        if (modalityIds.length > 0) {
          payloadWithOutGlobalFilter["chartConfigDto"]["modalityIds"] = modalityIds;
        }
        if (userIds.length > 0) {
          payloadWithOutGlobalFilter["chartConfigDto"]["userIds"] = userIds;
        }else{
          props.setAlertSuccessModal(() => {
            const newItem = { ...props.alertSuccessModal };
            newItem.show = true;
            newItem.heading = "Error";
            newItem.description = t("analytics.min-radiologist-selected");
            return newItem;
          });
      }
        if (raiseAlertReasonIds.length > 0) {
          payloadWithOutGlobalFilter["chartConfigDto"]["raiseAlerts"] = raiseAlertReasonIds;
        }else{
          payloadWithOutGlobalFilter["chartConfigDto"]["raiseAlerts"] = [];
        }
        return fetchRaiseAlertStudiesOnPlatform(payloadWithOutGlobalFilter);
      }else if ( props.chartType === "ai_tat_analysis" || props.chartType == "study_throughput" || props.chartType == "tat_analysis") {
          if (modalityIds.length > 0) {
            payloadWithOutGlobalFilter["chartConfigDto"]["modalityIds"] = modalityIds;
          }
          if (clientIds.length > 0) {
            payloadWithOutGlobalFilter["chartConfigDto"]["hospitalIds"] = clientIds;
          }
          if (bodyParts.length > 0) {
            payloadWithOutGlobalFilter["chartConfigDto"]["bodyParts"] = bodyParts;
          }

          if (aiModel.length > 0) {
            payloadWithOutGlobalFilter["chartConfigDto"]["aiModel"] = aiModel;
          }
          payloadWithOutGlobalFilter["chartConfigDto"]["normality"] = normality;

          payloadWithOutGlobalFilter["chartConfigDto"]["fullDay"] = filterObjInChartComponent.fullDay;
          return fetchStudyThrouhput(payloadWithOutGlobalFilter);
        }  else if (props.chartType === "ai_result") {   
        if (modalityIds.length > 0) {
            payloadWithOutGlobalFilter["chartConfigDto"]["modalityIds"] = modalityIds;
          }
          if (clientIds.length > 0) {
            payloadWithOutGlobalFilter["chartConfigDto"]["hospitalIds"] = clientIds;
          }
          if (bodyParts.length > 0) {
            payloadWithOutGlobalFilter["chartConfigDto"]["bodyParts"] = bodyParts;
          }
          if (aiModel.length > 0) {
            payloadWithOutGlobalFilter["chartConfigDto"]["aiModel"] = aiModel;
          }

          payloadWithOutGlobalFilter["chartConfigDto"]["fullDay"] = filterObjInChartComponent.fullDay;
         return fetchBarChart(payloadWithOutGlobalFilter);
      } else if (props.chartType === "radiologist_tat_trend") {
        if (modalityIds.length > 0) {
            payloadWithOutGlobalFilter["chartConfigDto"]["modalityIds"] = modalityIds;
          }
          if (clientIds.length > 0) {
            payloadWithOutGlobalFilter["chartConfigDto"]["hospitalIds"] = clientIds;
          }
          if (bodyParts.length > 0) {
            payloadWithOutGlobalFilter["chartConfigDto"]["bodyParts"] = bodyParts;
          }
          if (providerIds.length > 0) {
            payloadWithOutGlobalFilter["chartConfigDto"]["userIds"] = providerIds;
          }  
          payloadWithOutGlobalFilter["chartConfigDto"]["normality"] = normality;

          if (aiModel.length > 0) {
            payloadWithOutGlobalFilter["chartConfigDto"]["aiModel"] = aiModel;
          }   
        return fetchBarChart(payloadWithOutGlobalFilter);
    } else {
        if (modalityIds.length > 0) {
          payload["chartConfigDto"]["modalityIds"] = modalityIds;
        }
        if (clientIds.length > 0) {
          payload["chartConfigDto"]["hospitalIds"] = clientIds;
        }
        if (providerIds.length > 0) {
          payload["chartConfigDto"]["userIds"] = providerIds;
        }
        return fetchTAT(payload);
      }
    } else if (props.isPie) {
      if (pathologyIds.length > 0) {
        payload["chartConfigDto"]["annotationIds"] = pathologyIds;
      }
      return fetchPieChart(payload);
    }
  };

  const dataQuery = useQuery({
    queryKey: [props.chartType, props.filterObj, props.dateBy],
    queryFn: () => fetchData(),
    keepPreviousData: true,
    staleTime: Infinity, // Set stale time to 5 minutes
    gcTime: 15 * 60 * 1000, // Set cache time to 5 minutes (renamed from cacheTime)
    initialData: () => {
      return queryClient.getQueryData(["data"]);
    },
    initialDataUpdatedAt: () =>
      queryClient.getQueryState(["data"])?.dataUpdatedAt,
  });
  useEffect(() => {
    if(props.chartType == "study_throughput" || props.chartType == "tat_analysis" || props.chartType === "radiologist_tat_trend" || props.chartType === "ai_result" ){
      props?.setIsOnlineRadiologistSelected(true);
    }else{
      props?.setIsOnlineRadiologistSelected(false);
    }
  }, [])
  
  useEffect(() => {
    if (dataQuery.data) {
      if(props.chartType=="edit_reports_count" ||
         props.chartType=="returned_studies_count" ||
         props.chartType=="raised_alert_count" ||
         props.chartType=="study_throughput" ||
         props.chartType == "tat_analysis" ||
         props.chartType === "ai_tat_analysis"){
        if (props.isBar || props.isLineAvg) {
          setYAxisText(dataQuery.data.yAxisText);
          setIndexBy(dataQuery.data.indexby);
          setYAxisUnit(dataQuery.data.yAxisUnit);
          setXAxisUnit(dataQuery.data.xAxisUnit);
          setData(dataQuery.data.chartData);
          setKeys(dataQuery.data.chartKeys);
        } else {
          setData(dataQuery.data.chartData);
        }
        if (dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.userIds != undefined) {
          setProviderIds(dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.userIds);
        } else {
          setProviderIds([]);
        }
        if (dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.modalityIds != undefined) {
          setModalityIds(dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.modalityIds);
        } else {
          setModalityIds([]);
        }
        if (dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.hospitalIds != undefined) {
          setClientIds(dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.hospitalIds);
        } else {
          setClientIds([]);
        }
        if (dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.annotationIds != undefined) {
          setPathologyIds(dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.annotationIds);
        } else {
          setPathologyIds([]);
        }
        if (dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.userIds != undefined) {
          setUserIds(dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.userIds);
        }else{
          setUserIds([]);
        }
        if (dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.returnedReasons != undefined) {
          setReturnedReasonIds(dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.returnedReasons);
        }else{
          setReturnedReasonIds([]);
        }
        if (dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.raiseAlerts != undefined) {
          setRaiseAlertReasonIds(dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.raiseAlerts);
        }else{
          setRaiseAlertReasonIds([]);
        }
        if (dataQuery.data?.selectedDate != undefined) {
          setSelectedDate(dataQuery.data?.selectedDate);
        }else{
          setSelectedDate(2);
        }
        if (dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.filter != undefined) {
          setDateByInComponent(dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.filter == "upload_date" ? 1 : 2);
        }else{
          setDateByInComponent(1);
        }
        if (dataQuery.data?.totalCountForStudies != undefined || dataQuery.data?.totalCountForStudies != null) {
          console.log("total count in if ---",dataQuery.data?.totalCountForStudies);
          setTotalCountForStudies(dataQuery.data?.totalCountForStudies);
        }else{
          setTotalCountForStudies(0);
        }
        if (dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.dateFrom != undefined || dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.dateFrom != null) {
          let dateFrom = new Date(dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.dateFrom);
          let dateTo = new Date(dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.dateTo);
          console.log("date from-----------",dateFrom);
          console.log("date to-----------",dateTo);
          setFilterObjInChartComponent((prev) => ({
            ...prev,
            dateFrom: dateFrom,
            dateTo: dateTo
          }));
        }else{
          setFilterObjInChartComponent((prev) => ({
            ...prev,
            dateFrom: last2DaysDate,
            dateTo: todayDate
          }));
        }
        console.log("filterObjInChartComponent----------------------",filterObjInChartComponent);
        if(dataQuery.data?.heightForContainer != undefined && dataQuery.data?.heightForContainer != null){
          setHeightForContainer(dataQuery.data?.heightForContainer);
        }else{
          setHeightForContainer("90%");
        }
      }else{
        if (props.isBar || props.isLineAvg) {
          setYAxisText(dataQuery.data.yAxisText);
          setIndexBy(dataQuery.data.indexby);
          setYAxisUnit(dataQuery.data.yAxisUnit);
          setXAxisUnit(dataQuery.data.xAxisUnit);
          setData(dataQuery.data.chartData);
          setKeys(dataQuery.data.chartKeys);
        } else {
          setData(dataQuery.data.chartData);
        }
        if (dataQuery.data?.payload?.chartConfigDto?.userIds != undefined) {
          setProviderIds(dataQuery.data?.payload?.chartConfigDto?.userIds);
        } else {
          setProviderIds([]);
        }
        if (dataQuery.data?.payload?.chartConfigDto?.modalityIds != undefined) {
          setModalityIds(dataQuery.data?.payload?.chartConfigDto?.modalityIds);
        } else {
          setModalityIds([]);
        }
        if (dataQuery.data?.payload?.chartConfigDto?.hospitalIds != undefined) {
          setClientIds(dataQuery.data?.payload?.chartConfigDto?.hospitalIds);
        } else {
          setClientIds([]);
        }
        if (dataQuery.data?.payload?.chartConfigDto?.annotationIds != undefined) {
          setPathologyIds(dataQuery.data?.payload?.chartConfigDto?.annotationIds);
        } else {
          setPathologyIds([]);
        }
    }
  }}, [props.dateBy]);
const [drillDownDone, setDrillDownDone] = useState(false);

let clickTimer = null;
const handleBarClick = (barData) => {
  if (drillDownDone) return;

  if(props.chartType != "study_throughput" && props.chartType !== "ai_result"){
    return;
  }
  if (clickTimer !== null) {
    clearTimeout(clickTimer);
    clickTimer = null;
    const clickedLabel = barData.indexValue;
    handleDrillDownToHourly(clickedLabel);
    setDrillDownDone(true);

    // if (props.chartType === "ai_result") {
    //   handleDrillDownToHourly2(clickedLabel); 
    // } else if (props.chartType === "study_throughput") {
    //   handleDrillDownToHourly(clickedLabel);   
    // }
  } else {
    clickTimer = setTimeout(() => {
      clearTimeout(clickTimer);
      clickTimer = null;
    }, 300);
  }
};

const handleDrillDownToHourly = (label) => {
 const labelDate = new Date(label);  // label might be a string
 
 // Saving current date range
 setPreviousFilterObj({ ...filterObjInChartComponent });
// Updating from and to for drill-down view
 setFilterObjInChartComponent(prev => ({
    ...prev,
    dateFrom: labelDate,
    dateTo: labelDate,
    fullDay: true
  }));
  setDoubleClicked(true);
};
// const handleDrillDownToHourly2 = (label) => {
//  const labelDate = new Date(label);  // label might be a string
//   setFilterObjInChartComponent(prev => ({
//     ...prev,
//     dateFrom: labelDate,
//     fullDay: true
//   }));
//   setDoubleClicked(true);
// };

 useEffect(() => {
    if (doubleClicked) {
      fetchData();
      setDoubleClicked(false);
    }
  }, [doubleClicked]);

  useEffect(() => {
  if (props.chartType === "radiologist_tat_trend") {
    fetchData();
  }
}, []);
  useEffect(() => {
    if (props.chartType === "ai_tat_analysis" || props.chartType === "ai_result") {
      setClientIds([]);
      setPathologyIds([]);
      setModalityIds([]);
      setBodyParts([]);
      setAiModel([]);
      setProviderIds([]);
      setNormality("total");
      setFilterObjInChartComponent((prev) => ({
        ...prev,
        timeFrom: null,
        timeTo: null,
        dateFrom: defaulteFromDate,
        dateTo: todayDate,
        _clearTime: new Date().getTime(),
      }));
      setTimeout(() => {
        dataQuery.refetch();
      }, 100);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
// useEffect(() => {
//   if (
//     props.chartType === "ai_tat_analysis" ||
//     props.chartType === "radiologist_tat_trend" ||
//     props.chartType === "study_throughput" ||
//     props.chartType === "ai_result"
//   ) {
//     const today = new Date();
//     const oneMonthAgo = new Date(today);
//     oneMonthAgo.setMonth(today.getMonth() - 1);

//     setFilterObjInChartComponent(prev => ({
//       ...prev,
//       dateFrom: oneMonthAgo,
//       dateTo: today
//     }));
//   }
// }, [props.chartType]);

  // useEffect(() => {
  //   console.log('incomingChartMode:', incomingChartMode);
  //   console.log('widgetModeOpen:', widgetModeOpen);

  //   if (incomingChartMode && !widgetModeOpen) {
  //     setWidgetModeOpen(true); // ✅ mark as handled
  //     const today = new Date();
  //     const last7DaysDate = new Date();
  //     last7DaysDate.setDate(today.getDate() - 7);
  //       setFilterObjInChartComponent(prev => ({
  //         ...prev,
  //         dateTo: today,
  //         dateFrom: last7DaysDate
  //       }));
  //     setTimeout(() => {
  //       handleTATModeChange(incomingChartMode);
  //     }, 200);
  //   }
  // }, [incomingChartMode, widgetModeOpen]);

  useEffect(() => {
    console.log("filterObjInChartComponent");
    console.log(filterObjInChartComponent);

  },[filterObjInChartComponent]);

  const handleTATModeChange = (newKey) => {
    setSelectedTATType(newKey);
    setTimeout(() => {
      dataQuery.refetch(); 
    }, 1000);
  };
const hasChartData = Array.isArray(dataQuery?.data?.chartData) && dataQuery.data.chartData.length > 0;
  useEffect(() => {
  if (filterObjInChartComponent._clearTime && showDrilldownTable && selectedDrilldownDate) {
    const formattedDate = Moment(selectedDrilldownDate).format("YYYY-MM-DD");
    fetchStudyDrilldownDataNow(formattedDate);
  }
}, [filterObjInChartComponent._clearTime]);

  return (
    <>   
    {props.chartType === "radiologist_tat_trend" && !showDrilldownTable  && (
        <div style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "6px", 
          padding: "0px 22px",
          width: "100%",
          marginTop: "10px",
          marginBottom: "20px",
        }}>
          <div style={{
            display: "flex",
            borderRadius: "30px",
            overflow: "hidden",
            background: "#2b2f3a", // or use getThemeColor if needed
          }}>
            {/* 1. NEW BUTTON: Study Scan Time to Reporting Time */}
      <PrimaryButton
        onClick={() => handleTATModeChange("study_scan_tat_trend")}
        text="Study Scan to Reporting Time"
        style={{
          fontSize: "10px",
          fontWeight: "400",
          padding: "4px 10px",
          borderRadius: "0px",
          borderTopLeftRadius: "30px",
          borderBottomLeftRadius: "30px",
          background: selectedTATType === "study_scan_tat_trend" ? "#0078d4" : themeName != "light" ? "transparent" : "#EEE",
          color: selectedTATType === "study_scan_tat_trend" ? "white" : themeName != "light"? "#ccc":"black",
          border: "none",
          whiteSpace: "normal",        //  allow multiline
        }}
      />
      <div style={{
              width: "1px",
              backgroundColor: "#555", // or use getThemeColor
              // margin: "6px 0",
              // height: "20px",
              // alignSelf: "center"
              alignSelf: "stretch"
            }} />
      <div style={{ width: "1px", backgroundColor: "#555", alignSelf: "stretch" }} />
            <PrimaryButton
              onClick={() => handleTATModeChange("study_tat_trend")}
              text="Study Upload to Reporting Time"
              style={{
                fontSize: "10px",
                fontWeight: "400",
                padding: "4px 10px",
                borderRadius: "0px",
                // borderTopLeftRadius: "30px",
                // borderBottomLeftRadius: "30px",
                background: selectedTATType === "study_tat_trend" ? "#0078d4" : themeName != "light" ? "transparent" : "#EEE",
                color: selectedTATType === "study_tat_trend" ? "white" : themeName != "light"? "#ccc":"black",
                border: "none",
                whiteSpace: "normal", 
              }}
            />
            <div style={{
              width: "1px",
              backgroundColor: "#555", // or use getThemeColor
              // margin: "6px 0",
              // height: "20px",
              // alignSelf: "center"
              alignSelf: "stretch"
            }} />
            <PrimaryButton
              onClick={() => handleTATModeChange("assignment_tat_trend")}
              text="Study Assignment to Reporting Time"
              style={{
                fontSize: "10px",
                fontWeight: "400",
                padding: "4px 10px",
                borderRadius: "0px",
                background: selectedTATType === "assignment_tat_trend" ? "#0078d4" : themeName != "light" ? "transparent" : "#EEE",
                color: selectedTATType === "assignment_tat_trend" ? "white" : themeName != "light"? "#ccc":"black",
                border: "none",
                whiteSpace: "normal", 
              }}
            />
            <div style={{
              width: "1px",
              backgroundColor: "#555", // or use getThemeColor
              
              //alignSelf: "center"
              alignSelf: "stretch"
            }} />
            <PrimaryButton
              onClick={() => handleTATModeChange("radiologist_tat_trend")}
              text="Study Open to Reporting Time"
              style={{
                fontSize: "10px",
                fontWeight: "400",
                padding: "4px 10px",
                borderRadius: "0px",
                borderTopRightRadius: "30px",
                borderBottomRightRadius: "30px",
                background: selectedTATType === "radiologist_tat_trend" ? "#0078d4" : themeName != "light" ? "transparent" : "#EEE",
                color: selectedTATType === "radiologist_tat_trend" ? "white" : themeName != "light"? "#ccc":"black",
                border: "none",
                whiteSpace: "normal", 
              }}
            />
          </div>
        </div>
      )}

      <div
        style={{
          display: "flex",
          flexDirection: isPortraitMode ? "column" : "row",
          //  justifyContent: "center",
          paddingRight: "20px",
          paddingLeft: "20px",
          // paddingTop: (props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count") ? "" : "10px",
          position: "relative",
          // alignItems: "center",
          alignItems:"flex-start",
          marginBottom: (isPortraitMode && showDrilldownTable) ? "10px" : "-16px",
          marginTop: (props.chartType === "radiologist_tat_trend" && showDrilldownTable) ? "-5px" : "-5px",
          borderBottom: (props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count") ? "1px solid rgb(88, 88, 88)" : ""
        }}
      >
        {/* <PrimaryButton
          iconProps={addIcon}
          onClick={() => {
            setShowFilterOptions((prev) => !prev);
          }}
          text={t("analytics.add-filter")}
          style={
            showFilterOptions
              ? addFilterActive
              : {
                  fontSize: "12px",
                  fontWeight: "400",
                  padding: "0px 3px",
                  whiteSpace: "nowrap",
                }
          }
        /> */}
        <AnalyticsFilter
          show={showFilterOptions}
          modalityList={props.modalityList}
          clientList={props.clientList}
          annotationList={props.pathologyList}
          providerList={props.providerList}
          userList={props.userList}
          modalityIds={modalityIds}
          clientIds={clientIds}
          pathologyIds={pathologyIds}
          providerIds={providerIds}
          userIds={userIds}
          setClientIds={setClientIds}
          setModalityIds={setModalityIds}
          setPathologyIds={setPathologyIds}
          setProviderIds={setProviderIds}
          setUserIds={setUserIds}
          role={roles[0]}
          setAlertSuccessModal={props.setAlertSuccessModal}
          alertSuccessModal={props.alertSuccessModal}
          chartType={props.chartType}
          dateList={props.dateList}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          dateByInComponent={dateByInComponent}
          setDateByInComponent={setDateByInComponent}
          filterObjInChartComponent={filterObjInChartComponent}
          setFilterObjInChartComponent={setFilterObjInChartComponent}
          allModalitySelected={props.allModalitySelected}
          allRadiologistSelected={props.allRadiologistSelected}
          returnedReasonList={props.returnedReasonList}
          returnedReasonIds={returnedReasonIds}
          setReturnedReasonIds={setReturnedReasonIds}
          raiseAlertReasonList={props.raiseAlertReasonList}
          raiseAlertReasonIds={raiseAlertReasonIds}
          setRaiseAlertReasonIds={setRaiseAlertReasonIds}
          xrayBodyParts={props.xrayBodyParts}
          bodyParts={bodyParts}
          setBodyParts={setBodyParts}
          selectedTATType={selectedTATType}
          setSelectedTATType={setSelectedTATType}
          normality={normality}
          setNormality={setNormality}
          onTATTypeChange={handleTATModeChange}
          aiModel={aiModel}
          setAiModel={setAiModel}
          isPortraitMode={isPortraitMode}
          showMoreFilters={showMoreFilters}
          setShowMoreFilters={setShowMoreFilters}
        />
        {/* <div style={{display:"flex",flexDirection:"row", margin:"5px", paddingBottom:"10px", paddingLeft:"10px"}}> */}
        <div style={{ display: "flex", marginLeft: isPortraitMode ? "0" : "auto",
          gap: (props.chartType === "ai_result" ) ? "0px": "5px",
          //padding: "22px 5px 5px 0px"
          padding: isPortraitMode ? "0px 5px 5px 2px" : (props.chartType === "ai_result" || props.chartType === "radiologist_tat_trend" || props.chartType === "ai_tat_analysis" || props.chartType === "study_throughput" || props.chartType === "tat_analysis") ? "22px 5px 5px 2px": "5px 5px 5px 0px",
          alignItems: "center",
          flexWrap: "wrap",
          }}>
        {isPortraitMode && (props.chartType === "ai_tat_analysis" || props.chartType === "study_throughput" || props.chartType === "tat_analysis" || props.chartType === "radiologist_tat_trend" || (props.chartType === "ai_result" && !filterObjInChartComponent?.fullDay)) && (
          <PrimaryButton
            iconProps={{ iconName: 'AddTo', cursor: 'pointer' }}
            onClick={() => setShowMoreFilters((prev) => !prev)}
            text={
              [modalityIds, clientIds, bodyParts, pathologyIds, providerIds, aiModel].filter(arr => arr?.length > 0).length > 0
                ? `${t('productivity-gain.more-filters')} (${[modalityIds, clientIds, bodyParts, pathologyIds, providerIds, aiModel].filter(arr => arr?.length > 0).length})`
                : t('productivity-gain.more-filters')
            }
            styles={{
              root: [modalityIds, clientIds, bodyParts, pathologyIds, providerIds, aiModel].filter(arr => arr?.length > 0).length > 0
                ? { borderColor: "#0078d4", fontWeight: 600, fontSize: "12px", marginRight: "5px" }
                : { fontSize: "12px", marginRight: "5px" }
            }}
          />
        )}
        <PrimaryButton
          // onClick={() => {
          //   dataQuery.refetch();
          // }}
          onClick={() => {
            if (showDrilldownTable && selectedDrilldownDate) {
              fetchStudyDrilldownDataNow(
                Moment(selectedDrilldownDate).format("YYYY-MM-DD")
              );
            } else {
              dataQuery.refetch();
            }
          }}
          text={t("analytics.apply")}
          style={{
            fontSize: "12px",
            fontWeight: "400",
            padding: "0px 3px",
            whiteSpace: "nowrap",
            marginLeft: "5px",
          }}
        />

        {(props.chartType != "edit_reports_count" && props.chartType != "returned_studies_count" && props.chartType != "raised_alert_count") ? (
          <>
        <DefaultButton
          onClick={() => {
            //  const formattedDate = selectedDrilldownDate
            //   ? Moment(selectedDrilldownDate).format("YYYY-MM-DD")
            //   : null;
            setDrillDownDone(false); 

            // Time range is considered "set" by the user only when it is a
            // string option key (e.g. "02:00"); the default/cleared value is a
            // Date object or null, so detect a user-selected time range here.
            const timeRangeExist = (
              typeof filterObjInChartComponent.timeFrom === "string" ||
              typeof filterObjInChartComponent.timeTo === "string"
            );

            // a changed date range must also count as an applied filter,
            // otherwise Clear is a no-op when ONLY the "Reported Date Range" was changed.
            const atMidnight = (d) => (d ? new Date(d).setHours(0, 0, 0, 0) : null);
            const dateChanged = (
              atMidnight(filterObjInChartComponent.dateFrom) !== atMidnight(defaulteFromDate) ||
              atMidnight(filterObjInChartComponent.dateTo) !== atMidnight(todayDate)
            );

            const filtersExist = (
              clientIds.length > 0 ||
              pathologyIds.length > 0 ||
              modalityIds.length > 0 ||
              bodyParts.length > 0 ||
              aiModel.length > 0 ||
              providerIds.length > 0 ||
              normality !== "total" ||
              timeRangeExist ||
              dateChanged
            );
            if (!filtersExist && !showDrilldownTable) {
              //  Nothing to clear, so do nothing
              return;
            }

            //Clear filters
            setClientIds([]);
            setPathologyIds([]);
            setModalityIds([]);
            setBodyParts([]);
            setAiModel([]);
            setProviderIds([]);
            setNormality("total");
            
            // setFilterObjInChartComponent((prev) => ({
            //   ...prev,
            //   timeFrom: null,
            //   timeTo: null,
            //   fullDay: true,
            //    dateFrom: selectedDrilldownDate ? new Date(selectedDrilldownDate) : prev.dateFrom,
            //   dateTo: selectedDrilldownDate ? new Date(selectedDrilldownDate) : prev.dateTo,
            //   _clearTime: new Date().getTime() 
            // }));
            if (showDrilldownTable && selectedDrilldownDate) {
              const clearedFilter = {
                ...filterObjInChartComponent,
                timeFrom: null,
                timeTo: null,
                fullDay: true,
                dateFrom: new Date(selectedDrilldownDate),
                dateTo: new Date(selectedDrilldownDate),
                _clearTime: new Date().getTime(), // trigger refetch
              };
              setFilterObjInChartComponent(clearedFilter);
            } else {
              // Normal chart clear (date remains untouched)
              setFilterObjInChartComponent(prev => ({
                ...prev,
                timeFrom: null,
                timeTo: null,
                dateFrom: defaulteFromDate,
                dateTo: todayDate,
                _clearTime: new Date().getTime(), // trigger refetch
              }));
            setTimeout(() => {
              dataQuery.refetch();
            }, 100);
            }
            //  dateFrom: selectedDrilldownDate ? new Date(selectedDrilldownDate) : prev.dateFrom,
            //   dateTo: selectedDrilldownDate ? new Date(selectedDrilldownDate) : prev.dateTo
            // }));
            // Clear and reset main chart filter
            // const clearedFilter = {
            //   ...filterObjInChartComponent,
            //   timeFrom: null,
            //   timeTo: null,
            //   fullDay: true,
            //   dateFrom: selectedDrilldownDate ? new Date(selectedDrilldownDate) : filterObjInChartComponent.dateFrom,
            //   dateTo: selectedDrilldownDate ? new Date(selectedDrilldownDate) : filterObjInChartComponent.dateTo,
            //    _clearTime: new Date().getTime()
            // };

            // setFilterObjInChartComponent(clearedFilter);
            // setFiltersCleared(true); 
            // // Trigger the useEffect
              // if (formattedDate) {
              //   fetchStudyDrilldownDataNow(formattedDate,clearedFilter);
              // } else {
              //   dataQuery.refetch(); // fallback
              // }
          }}
          text={t("analytics.clear")}
          style={{
            fontSize: "12px",
            fontWeight: "400",
            padding: "0px 3px",
            whiteSpace: "nowrap",
            marginLeft: "5px",
          }}
        />
        {/*  Back Button shown only in ai_result + fullDay mode */}
      {((props.chartType === "ai_result" || props.chartType === "radiologist_tat_trend" || props.chartType === "ai_tat_analysis" )&& (filterObjInChartComponent.fullDay || showDrilldownTable )  && previousFilterObj) && (
        <DefaultButton
          onClick={() => {
            setFilterObjInChartComponent(previousFilterObj);
            setPreviousFilterObj(null);
            setDrillDownDone(false);          // Reset so next double-click works
            setDoubleClicked(false);
            setShowDrilldownTable(false);
            setTimeout(() => {
              dataQuery.refetch();
            }, 100);
          }}
          text="Back"
          //iconProps={{ iconName: "Back" }}
          style={{
            fontSize: "12px",
            fontWeight: "400",
            padding: "0px 3px",
            whiteSpace: "nowrap",
            marginLeft: "5px",
            // minWidth: "32px", // reduce width
            height: "28px",
          }}
          title="Back"
        />
      )}
    </>
  ) : (
        <DefaultButton
          onClick={() => {
            setDrillDownDone(false);
            handleResetChart();
          }}
          text={t("analytics.reset")}
          style={{
            fontSize: "12px",
            fontWeight: "400",
            padding: "0px 3px",
            whiteSpace: "nowrap",
            marginLeft: "5px",
          }}
        />
        )}
        </div>
      </div>
      {/* {props.chartType === "radiologist_tat_trend" && (
        <div style={{ display: "flex", alignItems: "left", padding: "0px 22px 0px" ,width: "100%",}}>
          <ChoiceGroup
            className="custom-tab-choicegroup"
            selectedKey={selectedTATType}
            options={[
              { key: "study_tat_trend", text: "Study Upload to Reporting Time" },
              { key: "assignment_tat_trend", text: "Study Assignment to Reporting Time" },
              { key: "radiologist_tat_trend", text: "Study Open Time to Reporting Time" },
            ]}
            onChange={(e, option) => {
              if (option) handleTATModeChange(option.key);
            }}
            styles={{
              root: { marginTop: 0 ,width: "100%"},
              flexContainer: { display: 'flex'},
            }}
          />
        </div>
      )} */}
      
      {props.chartType == "edit_reports_count" && <div style={{display:"flex",justifyContent:"center",marginTop:"10px"}}>
        <div className="form-mt-10" style={{width:"95%"}}>Total Count of Edited Reports by Radiologist: {totalCountForStudies}</div>
      </div>
      }
      {props.chartType == "returned_studies_count" && <div style={{display:"flex",justifyContent:"center",marginTop:"10px"}}>
        <div className="form-mt-10" style={{width:"95%"}}>Total Count of Returned Studies by Radiologist: {totalCountForStudies}</div>
      </div>
      }
      {props.chartType == "raised_alert_count" && <div style={{display:"flex",justifyContent:"center",marginTop:"10px"}}>
        <div className="form-mt-10" style={{width:"95%"}}>Total Count of Raise Alert Studies by Radiologist: {totalCountForStudies}</div>
      </div>
      }
      <div
        ref={chartWrapperRef}
        style={{
          marginTop: isPortraitMode ? "30px" : showDrilldownTable ? "15px" : "0px",
          ...(isPortraitMode && !showDrilldownTable && { border: "1px solid #585858", borderRadius: "4px", paddingBottom: "50px", boxSizing: "border-box" }),
          height: (isPortraitMode && chartContainerWidth > 0 && !showDrilldownTable)
            ? `${chartContainerWidth * (950 / 1250)}px`
            : heightForContainer,
          // minHeight: (props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count") ? "73%" : "90%",
            minHeight: (isPortraitMode && chartContainerWidth > 0 && !showDrilldownTable) ? "unset" : (() => {
              if (props.chartType === "ai_tat_analysis" && showDrilldownTable) {
                return "calc(100% - 140px)";
              }
              switch (props.chartType) {
                case "edit_reports_count":
                case "returned_studies_count":
                case "raised_alert_count":
                  return "73%";
                case "radiologist_tat_trend":
                  return "calc(100% - 140px)";
                case "ai_tat_analysis":
                  return "calc(100% - 68px)";
                case "ai_result":
                  return "calc(100% - 75px)";
                case "study_throughput":
                case "tat_analysis":
                  return "90%";
                default:
                  return "90%";
              }
            })(),
            width: "100%",
            display: "flex",
            alignItems: showDrilldownTable ? "flex-start" : "center",
            justifyContent: "center",
          }}
      >
        <div
          style={{
            height: "100%",
            width: ((props.chartType === "radiologist_tat_trend" || props.chartType === "ai_tat_analysis" )&& showDrilldownTable) ? "100%" : "95%",
            display: "flex",
            alignItems: showDrilldownTable ? "flex-start" : "center",
            justifyContent: "center",
          }}
        >
          {props.isBar && data.length > 0 && (
            <BarChartNivo
              data={data}
              keys={keys}
              chartType={props.chartType}
              indexBy={indexBy}
              xAxisUnit={xAxisUnit}
              yAxisText={yAxisText}
              yAxisUnit={yAxisUnit}
              totalCountForStudies={totalCountForStudies}
              filterObjInChartComponent={filterObjInChartComponent}
              handleBarClick={handleBarClick}
            />
          )}
          {props.isLine  && data.length > 0 &&  (  
            <LineChartNivo
              data={data}
              yAxisText={yAxisText}
              //chartType={props.chartType}
              chartType={selectedTATType}

            />
          )}
          {props.isPie && data.length > 0 && <PieChart data={data} />}
          {props.isLineAvg && data.length > 0 && !(isPortraitMode && showDrilldownTable) && (
            // <MultiLineChartNivo
            //   data={data}
            //   keys={keys}
            //   chartType={props.chartType}
            //   indexBy={indexBy}
            //   yAxisText={yAxisText}
            //   totalCountForStudies={totalCountForStudies}
            //   filterObjInChartComponent={filterObjInChartComponent}
            // />
            <TATCombinedChart 
              data={data} 
              normality={normality} 
              chartType={props.chartType}     
              onPointDoubleClick={handleTATPointDoubleClick}
            />
          )}
          {data.length <= 0 && props.isPie && (
            <div>
              No data to display. Please select findings to display the
              "Study Distribution based on findings" pie chart.
            </div>
          )}
          {data.length <= 0 && (props.isBar || props.isLineAvg) && showDrilldownTable === "false" && (
            <div>
              No data to display. Please add filters to display the chart.
            </div>
          )}
          {/* {showDrilldownTable && selectedDrilldownDate && (
            // <StudyDrilldownTable selectedDate={selectedDrilldownDate} />
            <StudyDrilldownTable 
            // selectedDate={selectedDrilldownDate} 
            selectedDate={Moment(selectedDrilldownDate).format("YYYY-MM-DD")}  // ✅ Fix here
            // chartConfigDto={payloadWithOutGlobalFilter.chartConfigDto}
            chartConfigDto={{
                ...payloadWithOutGlobalFilter.chartConfigDto,
                modalityIds,
                hospitalIds: clientIds,
                userIds: providerIds,        
                bodyParts,
                aiModel,
                normality,
                dateFrom: selectedDrilldownDate,  // override to clicked date
                dateTo: selectedDrilldownDate,
              }}            
              hospitalIdsMappedToCurrentUser={clientIds}
              userIds={providerIds}
            />
          )} */}
          {showDrilldownTable && selectedDrilldownDate && (
          <StudyDrilldownTable 
            selectedDate={Moment(selectedDrilldownDate).format("YYYY-MM-DD")}
            data={drilldownTableData} 
            />
          )}

        </div>
      </div>

  {/* {props.chartType === "radiologist_tat_trend" && (
    <p style={{ fontSize: "12px", marginTop: "1px", marginLeft: "30px", color: "#aaa" }}>
      <strong>*</strong> <em>Note: This TAT chart and its filters apply only to the radiologist workflow analysis.</em>
    </p>
  )} */}

  {(props.chartType === "study_throughput" || props.chartType === "ai_result") &&
  !filterObjInChartComponent?.fullDay && (
    hasChartData  ? (
    <p style={{ fontSize: "14px", marginTop: "0px", marginLeft: "25px", color: "var(--navbar-username)" }}>
      <strong>*</strong> <em>Note: Double Click on a bar to drill down and view the hourly distribution of studies for that day.</em>
    </p>
    ) : (
      <p style={{ fontSize: "14px", marginTop: "-220px", textAlign: "center", color: "var(--navbar-username)" }}>
        No Study Found (Please clear any applied filters)
      </p>
    )
  )}
   {/* {(props.chartType === "radiologist_tat_trend" || props.chartType === "ai_tat_analysis") &&
  !showDrilldownTable && (
    <p style={{ fontSize: "14px", marginTop: "0px", marginLeft: "25px", color: "#aaa" }}>
      <strong>*</strong> <em>Note: Double Click on a point to view the complete study list reported on that day</em>
    </p>
  )} */}

  {(props.chartType === "radiologist_tat_trend" || props.chartType === "ai_tat_analysis") &&
  !showDrilldownTable && (
    hasChartData  ? (
      <p style={{ fontSize: "14px", marginTop: "0px", marginLeft: "25px", color: "var(--navbar-username)" }}>
        <strong>*</strong> <em>Note: Double Click on a point to view the complete study list reported on that day</em>
      </p>
    ) : (
      <p style={{ fontSize: "14px", marginTop: "-220px", textAlign: "center", color: "var(--navbar-username)" }}>
        No Study Found (Please clear any applied filters)
      </p>
    )
)}


    </>
  );
};

export default ChartComponent;
